import React from 'react';
import Axios from 'axios';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

import SeasonAdmin_nav from './SeasonAdmin_nav';

const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

/*
db.users.find({charterAdmin: "QVNEA"}, {auth0_user_id:1, name: 1}).pretty()
{
        "_id" : ObjectId("5959016919070c61b8b267ca"),
        "auth0_user_id" : "facebook|10158223322283768",
        "name" : "Patrick Poulin"
},{
        "_id" : ObjectId("595a651819070c61b8b267cf"),
        "auth0_user_id" : "facebook|10159514195364789",
        "name" : "Pascal Grenier"
},{
        "_id" : ObjectId("595a6dcc19070c61b8b267ed"),
        "auth0_user_id" : "google-oauth2|107539683662924942267",
        "name" : "Patrick Poulin"
},{
        "_id" : ObjectId("59b45b9f9f62764e0f224d8a"),
        "auth0_user_id" : "google-oauth2|118101650774239654028",
        "name" : "Marco Sanschagrin"
},{
        "_id" : ObjectId("5a981e7cb8258a39c8263dbf"),
        "auth0_user_id" : "google-oauth2|106560438452072565351",
        "name" : "Patrick Poulin"
},{
        "_id" : ObjectId("5a9869b7b8258a39c827ff37"),
        "auth0_user_id" : "google-oauth2|118101650774239654028",
        "name" : "Marco Sanschagrin"
},{
        "_id" : ObjectId("5babe7f7a07343154d5773e4"),
        "auth0_user_id" : "facebook|10158190966192108",
        "name" : "Cynthia Pelletier"
},{
        "_id" : ObjectId("5d7131c45160c7272cd0be02"),
        "auth0_user_id" : "google-oauth2|102706535363350051482",
        "name" : "Pascal Grenier"
}

db.users.update({charterAdmin: "QVNEA"}, {$set: {charterAdmin: "QVNEA-MASTER"}}, false, true)
*/

const cstTableHeaders = [
	'Joueur', 'Équipe', 'Inscriptions', 'Paiements', 'Bourses', 'Versements', 'Transferts', 
	'Solde Ligue', 'Inscriptions CM', 'Paiements CM', 'Transferts CM', 'Solde CM', 'Compte du Joueur', 'Solde du Joueur', 'Paiement Ligue'];

const cstDefaultSortOrder = [
	'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc'];

const cstDefaultSortFieldIdx = 0;
const cstDetaultTotal = {
	inscription: 0, paiement: 0, bourse:0, versement: 0, transfert: 0, balance: 0, 
	mscInscription: 0, mscPaiement: 0, mscTransfert:0, mscBalance: 0, 
	playerAccount: 0, playerBalance: 0
};

const cstAccountTransferBtnColIdx = 14;
const cstPlayerIdColIdx = 15;
const cstHasBeenModifiedColIdx = 16;

class SeasonAdmin_qvneaSummary extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			charterAdminMode: "",

			dataTable1: [],
			sortFieldIdx1: cstDefaultSortFieldIdx,
			sortOrder1: cstDefaultSortOrder[cstDefaultSortFieldIdx],

			dataTable2: [],
			sortFieldIdx2: cstDefaultSortFieldIdx,
			sortOrder2: cstDefaultSortOrder[cstDefaultSortFieldIdx],

			playersRegTotal: cstDetaultTotal,
			playersNoTeamTotal: cstDetaultTotal,
			loading: true
		};

		this.createDataTables = this.createDataTables.bind(this);
		this.sortdataTable = this.sortdataTable.bind(this);
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.handleRefreshButton = this.handleRefreshButton.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
	}

 	componentDidMount() {
		//console.log('SeasonAdmin_qvneaSummary: componentDidMount');
 		var charterAdminMode = "";
		if (this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) {
			charterAdminMode = "MASTER";
		} else if (this.props.adminAccess.charterAdmin.indexOf('QVNEA-ASSIST') !== -1) {
			charterAdminMode = "ASSIST";
		}
		this.setState({ charterAdminMode: charterAdminMode });

		this.loadPlayersSeasonBalance(this.props.season);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('SeasonAdmin_qvneaSummary: UNSAFE_componentWillReceiveProps: ');
		//console.log(nextProps);

		this.setState({loading: true});
		this.loadPlayersSeasonBalance(nextProps.season);
	}

  loadPlayersSeasonBalance(season) {
		// season is empty on first renders when refreshing page (due to league change first with no season)
    if (season._id !== undefined) {
	    var _this = this;
	    Axios.get('/api/qvneaBooks/seasonPlayersBalance/' + season._id).then(function (response) {
	    	
	    	//console.log('SeasonAdmin_qvneaSummary: loadPlayersSeasonBalance')
	    	//console.log(response.data)
      	_this.createDataTables(response.data);
			});
		}
  }

	createDataTables(dataResults) {
		var _this = this;
		var dataTable1 = [];
		var dataTable2 = [];

		this.setState({
			playersRegTotal: dataResults.playersRegTotal,
			playersNoTeamTotal: dataResults.playersNoTeamTotal
		});

		_this.buildOneDataTable(dataTable1, dataResults.playersReg, function() {
		_this.buildOneDataTable(dataTable2, dataResults.playersNoTeam, function() {
			_this.sortdataTable(dataTable1, _this.state.sortFieldIdx1, _this.state.sortOrder1, 1);
			_this.sortdataTable(dataTable2, _this.state.sortFieldIdx2, _this.state.sortOrder2, 2);

			_this.setState({
				loading: false
			});

		});
		});
	}

	buildOneDataTable(dataTable, playersData, callback) {
		playersData.forEach(function(result, resultIdx) {
			var dataTableRow = [];
	
			// Calculate Transfer Button usage here
			var txBtnValue = 0;
			if ((result.qvneaBooks.balance < 0) && (result.qvneaBooks.playerAccount >= -result.qvneaBooks.balance)) {
				txBtnValue = -result.qvneaBooks.balance;
			}

			// dataTableRow.push(0);		// rank
			dataTableRow.push(result.fullname);
			dataTableRow.push(result.team);
			dataTableRow.push(result.qvneaBooks.inscription);
			dataTableRow.push(result.qvneaBooks.paiement);
			dataTableRow.push(result.qvneaBooks.bourse);
			dataTableRow.push(result.qvneaBooks.versement);
			dataTableRow.push(result.qvneaBooks.transfert);
			dataTableRow.push(result.qvneaBooks.balance);
			dataTableRow.push(result.qvneaBooks.mscInscription);
			dataTableRow.push(result.qvneaBooks.mscPaiement);
			dataTableRow.push(result.qvneaBooks.mscTransfert);
			dataTableRow.push(result.qvneaBooks.mscBalance);
			//dataTableRow.push(result.qvneaBooks.balance + result.qvneaBooks.mscBalance);
			dataTableRow.push(result.qvneaBooks.playerAccount);
			dataTableRow.push(result.qvneaBooks.playerBalance);
			dataTableRow.push(txBtnValue);
			dataTableRow.push(result._id);
			dataTableRow.push("");

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		callback();
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder, tableIdx) {

		// Manage empty data
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {
				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) {
					return (sortSign * compVal);
				} else {

					compVal = a[1].localeCompare(b[1]);
					if (compVal !== 0) {
						return compVal;
					} else {
						return a[0].localeCompare(b[0]);
					}
				}
			});
		}

		if (tableIdx === 1) {
			this.setState({
				dataTable1: dataTable,
				sortFieldIdx1: sortFieldIdx,
				sortOrder1: sortOrder,
			});
		} else {
			this.setState({
				dataTable2: dataTable,
				sortFieldIdx2: sortFieldIdx,
				sortOrder2: sortOrder,
			});		
		}
	}

 	render() {
		//console.log('SeasonAdmin_qvneaSummary: RENDER');
		//console.log(this.props)
		var sortClass = this.state.sortClass;

    // ADMIN LEVEL REQUESTED:  03-SEASON
    if (this.props.adminAccess.adminValidatedAccessLevel > ADMIN_LVL_SCORESHEETS) {

      return (
        <div className="col-md-9">   {/*padding-left already set in parent*/} 
          <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
        </div>
      );
    } else {

			if(this.props.season._id === "0") {
        return (
	        <div className="col-md-9">   {/*padding-left already set in parent*/} 
            <p>Vous devez d'abord créer une saison pour cette ligue dans l'onglet Ligue</p>
          </div>
        );

			} else {

				return (
          <div>
        		<SeasonAdmin_nav adminAccess={this.props.adminAccess} season={this.props.season} />

          	<div className="row">
          	<div className="col-md-12">
							<h5>QVNEA - SOMMAIRE DES FINANCES - LIGUE ET CARTE DE MEMBRE</h5>
							<p className="qvneaSummaryRedFont">
								En appuyant sur le bouton "Payer Ligue", la ligne devient rouge pour indiquer qu'elle a été modifiée.<br/>
								Recharger les tables pour voir les changements appliqués.
							</p>

							{(this.state.loading) ?
								this.displaySpinner()	:
							<React.Fragment>

			         	<div className="row">
			          	<div className="col-md-12">
										<button type="button" className="btn btn-secondary btn-refresh no-margin pull-right"
											onClick={this.handleRefreshButton} > 
											Recharger les Tables &nbsp;<i className="fa fa-refresh"></i>
										</button>
				         	</div>
			         	</div>

								<h6>JOUEURS SUPPRIMÉS AVEC DES ENTRÉES DANS LES QVNEA BOOKS</h6>
								<div className="table-responsive">
								<table className="table table-hover table-sm">
								<thead>
									<tr>
									{cstTableHeaders.map(this.createTableHdrRow.bind(this, 2))}
									</tr>
								</thead>

								{this.createTotalRow(this.state.playersNoTeamTotal)}
								{this.displayTable2()}
								</table>
								</div>

								<br/>
								<h6>JOUEURS RÉGULIERS</h6>

								<div className="table-responsive">
								<table className="table table-hover table-sm">
								<thead>
									<tr>
									{cstTableHeaders.map(this.createTableHdrRow.bind(this, 1))}
									</tr>
								</thead>

								{this.createTotalRow(this.state.playersRegTotal)}
								{this.displayTable1()}
								</table>
								</div>
							</React.Fragment>
						}

          	</div>
          	</div>
          </div>
        );
			}
		}
  }

	handleRefreshButton() {
		this.setState({loading: true});
		this.loadPlayersSeasonBalance(this.props.season)
	}

	createTableHdrRow(tableIdx, hdrItem, hdrIdx) {
		if (hdrIdx >= cstPlayerIdColIdx) {
			return;
		}

		// ID Visible only in master mode
		var classNameStr = '';
		var onClickAction = function() {};

		var sortFieldIdx = 0;;
		var sortOrder = "asc";
		if (tableIdx === 1) {
			sortFieldIdx = this.state.sortFieldIdx1;
			sortOrder = this.state.sortOrder1;
			onClickAction = this.handleSortTable.bind(this, 1);

		} else if (tableIdx === 2) {
			sortFieldIdx = this.state.sortFieldIdx2;
			sortOrder = this.state.sortOrder2;
			onClickAction = this.handleSortTable.bind(this, 2);
		}

		// Sort with arrows
		classNameStr = 'statelo-sorting';
		if(hdrIdx === sortFieldIdx) {
			if (sortOrder === "asc") {
				classNameStr += ' statelo-sorting_asc';
			} else {
				classNameStr += ' statelo-sorting_desc';
			}
		}

		var colWidth = "auto";
		if (hdrIdx >= 2) {
			colWidth = "80px";
			classNameStr += " text-right";
		}

		var charterAdminMode = this.state.charterAdminMode;
		if ((hdrIdx === 2) || (hdrIdx === 12) || 
			  ((charterAdminMode !== "ASSIST") && (hdrIdx === 8)) || 
			  ((charterAdminMode === "ASSIST") && (hdrIdx === 11)) ) {
			classNameStr += " tdLeftBorder";
		}

		if ((charterAdminMode === "ASSIST") && (hdrIdx >= 8) && (hdrIdx <= 10)) {
			return;
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}
				width={colWidth}>
				{hdrItem}
			</th>
		);
	}

	displayTable2() {
		if (this.state.dataTable2.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun joueur</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.dataTable2.map(this.createDataRow.bind(this, 2))}
				</tbody>
			)
		}
	}

	displayTable1() {
		if (this.state.dataTable1.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun joueur</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.dataTable1.map(this.createDataRow.bind(this, 1))}
				</tbody>
			)
		}
	}

	createTotalRow(playersTotal) {
		var charterAdminMode = this.state.charterAdminMode;
		return (
			<tbody>
			<tr className="headBackground">
				<td>Total</td>
				<td></td>
				<td className="text-right tdLeftBorder">{playersTotal.inscription.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.paiement.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.bourse.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.versement.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.transfert.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.balance.toFixed(2) + ' $'}</td>
				{	(charterAdminMode === "MASTER") ?
					<React.Fragment>
					<td className="text-right tdLeftBorder">{playersTotal.mscInscription.toFixed(2) + ' $'}</td>
					<td className="text-right">{playersTotal.mscPaiement.toFixed(2) + ' $'}</td>
					<td className="text-right">{playersTotal.mscTransfert.toFixed(2) + ' $'}</td>
					</React.Fragment>
				 : null}
				<td className="text-right">{playersTotal.mscBalance.toFixed(2) + ' $'}</td>
				<td className="text-right tdLeftBorder">{playersTotal.playerAccount.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.playerBalance.toFixed(2) + ' $'}</td>

				<td></td>
      </tr>
			</tbody>
		)
	}

  createDataRow(tableIdx, dataRow, dataRowIdx) {
  	var thisDataTable = (tableIdx === 2) ? [...this.state.dataTable2] : [...this.state.dataTable1];
  	var specialClass = (thisDataTable[dataRowIdx][cstHasBeenModifiedColIdx] === "MODIFIED") ? "qvneaSummaryRedFont" : "";

		return (
			<tr key={'te.' + dataRowIdx} className={specialClass}>
				{dataRow.map(this.createDataCell.bind(this, tableIdx, dataRowIdx))}
      </tr>
    );
  }

 	createDataCell(tableIdx, dataRowIdx, dataCell, dataCellIdx) {
		var charterAdminMode = this.state.charterAdminMode;

		if (dataCellIdx >= cstPlayerIdColIdx) {
			return;
		}

 		var classNameStr = "";
 		if ((dataCellIdx === 7) || (dataCellIdx === 11)) {
 			classNameStr = "font-weight-bold";
 		}

 		if ((dataCellIdx > 1) && (dataCellIdx < cstAccountTransferBtnColIdx)) {
 			dataCell = dataCell.toFixed(2) + ' $';
 			classNameStr += " text-right";
 		}

		if ((dataCellIdx === 2) || (dataCellIdx === 12) ||
			  ((charterAdminMode !== "ASSIST") && (dataCellIdx === 8)) || 
			  ((charterAdminMode === "ASSIST") && (dataCellIdx === 11)) ) {
			classNameStr += " tdLeftBorder";
		}

		if ((charterAdminMode === "ASSIST") && (dataCellIdx >= 8) && (dataCellIdx <= 10)) {
			return;
		}

		// Bouton: Ajustement avec Compte Joueur
		var accountAdjustBtnTxt = "";
		var extraClassName = "";
		var spanClassName = "";
		var showBtn = (dataCell !== 0);

  	var thisDataTable = (tableIdx === 2) ? [...this.state.dataTable2] : [...this.state.dataTable1];
  	var bRowModified = (thisDataTable[dataRowIdx][cstHasBeenModifiedColIdx] === "MODIFIED");

		if (dataCellIdx === cstAccountTransferBtnColIdx) {
			if ((dataCell !== 0) && !bRowModified) {
				accountAdjustBtnTxt = " Payer Ligue";
				extraClassName = "btn-primary btn-qvnea-player-account-balance";
				spanClassName = "fa fa-arrow-left";

				return (
					<td className={classNameStr + " text-center td-qvnea-btn-padding"} key={"tdcell." + dataCellIdx}>
						<button type="button" className={"btn btn-sm2 " + extraClassName}
							onClick={this.handleSetAccountBalanceClick.bind(this, tableIdx, dataRowIdx)}>
							<span className={spanClassName}>{accountAdjustBtnTxt}</span>
						</button>
					</td>
				)
			}
			else {
				return ( <td className={classNameStr} key={"tdcell." + dataCellIdx}></td> )
			}
		} else {
			return ( <td className={classNameStr} key={"tdcell." + dataCellIdx}>{dataCell}</td> )
		}
	}

  handleSetAccountBalanceClick(tableIdx, dataRowIdx, e) {
  	var _this = this;
  	var dataTable1 = this.state.dataTable1;
  	var dataTable2 = this.state.dataTable2;

  	var thisDataTable = (tableIdx === 2) ? dataTable2 : dataTable1;
  	var thisTableItem = thisDataTable[dataRowIdx];

  	var playerId = thisTableItem[cstPlayerIdColIdx];
    var amount = thisTableItem[cstAccountTransferBtnColIdx];

    var leagueId = this.props.season.leagueId;
    var seasonId = this.props.season._id;
		var txDirection = "fromPlayerAccount";
    
		var myDate = new Date();
		myDate.setUTCHours(12,0,0,0);
   
  	var operationObj = {
  		date: myDate,
  		user: this.props.profile.name,
  		txDirection: txDirection,
  		amount: amount,
  		leagueId: leagueId,
  		seasonId: seasonId,
  		playerId: playerId
  	};

		// Post operation
		Axios.post('/api/qvneaBooks/savePlayerAccountTransfer', {
			sourceType: 'seasonSummary',
			operationObj: operationObj,
		})
		.then(function(response) {
  		thisDataTable[dataRowIdx][cstHasBeenModifiedColIdx] = "MODIFIED";
    	_this.setState({
    		dataTable1: dataTable1,
    		dataTable2: dataTable2
    	});
		})
		.catch(function(error) {
			console.log('ERROR');
			console.log(error);
		});
  }

	handleSortTable(tableIdx, e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		var dataTable = this.state.dataTable1;
		var sortOrder = this.state.sortOrder1;
		var prevSortFieldIdx = this.state.sortFieldIdx1;
		if (tableIdx === 2) {
			dataTable = this.state.dataTable2;
			sortOrder = this.state.sortOrder2;
			prevSortFieldIdx = this.state.sortFieldIdx2;
		}

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder, tableIdx);
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default SeasonAdmin_qvneaSummary;

